export const UserDataStore = {
    apps: [] //Elenco delle app collegate all'utente loggato
};
